<script setup lang="ts">
import { enUS } from 'date-fns/locale'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'

import { faCalendar } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { IconContainer, RowSlot } from '@shared/ui/other'

import { useTutorKanbanFinalDayConfirm } from '../../model/tutor-kanban-final-day-confirm.hook'
import { useTutorKanbanPickerFinalDay } from '../../model/tutor-kanban-picker-final-day.hook'
import ModalConfirmExitChange from '../../ui/modals/ModalConfirmExitChange.vue'

defineOptions({
  name: 'TutorKanbanPickerFinalDay',
})

const {
  isVisible,
  refDate,
  refMinDate,
  setChange,
} = useTutorKanbanPickerFinalDay()

const {
  isConfirmOpen,
  setConfirmChange,
  setCancelChange,
} = useTutorKanbanFinalDayConfirm()
</script>

<template>
  <RowSlot
    v-if="isVisible"
    label="Final Day"
  >
    <div class="tkb-picker-final-day">
      <Datepicker
        :model-value="refDate"
        model-type="yyyy-MM-dd"
        :min-date="refMinDate"
        :locale="enUS"
        :week-start="1"
        :formats="{ input: 'MMM dd, yyyy' }"
        :time-config="{ enableTimePicker: false }"
        :clearable="true"
        auto-apply
        placeholder="Select date"
        :teleport-center="true"
        @update:model-value="setChange"
      >
        <template #input-icon>
          <IconContainer>
            <FontAwesomeIcon :icon="faCalendar" />
          </IconContainer>
        </template>
      </Datepicker>
    </div>
    <ModalConfirmExitChange
      :show="isConfirmOpen"
      title="Start the tutor's exit now?"
      detail="Saving the Final Day starts the exit right away: lessons after it are cancelled and the tutor's students go to reactivation."
      @click:confirm="setConfirmChange"
      @click:cancel="setCancelChange"
    />
  </RowSlot>
</template>

<style scoped lang="scss" src="./TutorKanbanPickerFinalDay.scss" />
